import {hpcAttrs} from '@github-ui/hpc'
import {Heading, PageLayout} from '@primer/react'
import {TabNav} from '@primer/react/deprecated'
import {Link} from '@github-ui/react-core/link'
import {CreateBranchButton} from '@github-ui/create-branch-button-ui'
import type {PropsWithChildren} from 'react'
import {useCreateBranchButtonOptions} from '../contexts/CreateBranchButtonOptionContext'
import type {BranchPageType} from '../types'
import {BRANCH_PAGES} from '../constants'
import SearchInput from './SearchInput'
import BranchPagination from './BranchPagination'
import useBranchTabPath from '../hooks/use-branch-tab-path'
import {useCurrentRepository} from '@github-ui/current-repository'

import styles from './Layout.module.css'

export default function Layout({
  selectedPage,
  children,
}: PropsWithChildren<{
  selectedPage: BranchPageType
}>) {
  const {currentUserCanPush} = useCurrentRepository()
  const getBranchTabPath = useBranchTabPath()
  const createButtonOptions = useCreateBranchButtonOptions()

  return (
    <PageLayout>
      <PageLayout.Header>
        <div className={styles.HeaderContainer}>
          <Heading as="h1" className={styles.Heading}>
            Branches
          </Heading>
          <div className={styles.HeaderActions}>
            {currentUserCanPush && <CreateBranchButton {...createButtonOptions} liveReload />}
          </div>
        </div>
      </PageLayout.Header>
      <PageLayout.Content as="div">
        <div className={styles.ContentContainer}>
          <TabNav>
            {BRANCH_PAGES.filter(({onlyShowForPushUsers}) => currentUserCanPush || !onlyShowForPushUsers).map(page => (
              <TabNav.Link
                key={page.type}
                as={Link}
                to={getBranchTabPath(page.type)}
                selected={page.type === selectedPage}
              >
                {page.title}
              </TabNav.Link>
            ))}
          </TabNav>

          <SearchInput selectedPage={selectedPage} />

          <div {...hpcAttrs()}>{children}</div>

          {selectedPage !== 'overview' ? <BranchPagination /> : null}
        </div>
      </PageLayout.Content>
    </PageLayout>
  )
}
